import React, { FC, useContext, useEffect } from 'react'

import { Layout } from 'antd'
import HeaderApp from 'Components/HeaderApp'
import Loading from 'Components/Loading'
import { ApplicationContext } from 'Context'

import InnerContent from '../InnerContent'

const { Content } = Layout

const LayoutMisto: FC = () => {
  const { applicationContext } = useContext(ApplicationContext)

  useEffect(() => {
    if (!applicationContext.usuarioAtual) {
      location.assign('/session-close')
    }
  }, [])

  return (
    <Layout style={{ height: '100vh' }}>
      {applicationContext.loading ? (
        <Loading />
      ) : (
        <>
          <HeaderApp />
          <Content style={{ padding: '64px 20px 10px' }}>
            <InnerContent></InnerContent>
          </Content>
        </>
      )}
    </Layout>
  )
}

export default LayoutMisto
